module.exports = __webpack_public_path__ + "static/img/gya_22.26b3475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/line/gya_22.jpg
// module id = BixT
// module chunks = 0